import { render } from "./availablerooms.vue?vue&type=template&id=18d804ba"
import script from "./availablerooms.vue?vue&type=script&lang=js"
export * from "./availablerooms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__